import SideBar from '../../components/global/SideBar.tsx';
import './index.css';
import { AwardList } from '../../components/awards/AwardList.tsx';
import { ProgressSection } from '../../components/awards/ProgressSection.tsx';
import type { Awards } from '../../components/awards/ProgressSection.tsx';
import LevelProgress from '../../components/awards/LevelProgress.tsx';
import CurrentLevel from '../../components/awards/CurrentLevel.tsx';
import { AcceptAwards } from '../../components/awards/AcceptAwards.tsx';
import { Loader, useCurrentUser } from '@beholos/holoscommon';
import { useEffect, useState } from 'react';
import { usePageTitle } from '../../hooks/usePageTitle';
import type { Level } from '../../types/level.interface.ts';
import { getAwards, getLevels } from '../../services/award.service.ts';

export default function Acheivements() {
  usePageTitle('Mis Logros - Holos');
  const { user, loading: loadingUser, refetch } = useCurrentUser();
  const { firstname = '' } = user || {};
  const { levelName, fitPoints, points, accepted, progressWidth } = user?.rewards || {};
  const [levels, setLevels] = useState<Level[]>([]);
  const [loading, setLoading] = useState(true);
  const [awards, setAwards] = useState<Awards | null>(null);

  useEffect(() => {
    getLevels()
      .then((data: Level[]) => setLevels(data))
      .catch((error: any) => console.error(error))
      .finally(() => setLoading(false));

    getAwards()
      .then((data: Awards) => setAwards(data))
      .catch((error: any) => console.error(error));
  }, []);

  return (
    <div className="flex h-[calc(100vh-80px)] w-screen overflow-hidden">
      <div className="hidden md:block md:w-80 lg:w-96 h-full overflow-y-auto">
        <SideBar />
      </div>

      <div className="flex-1 h-full overflow-y-auto bg-gray-200 py-15 px-6">
        {loadingUser || loading ? <Loader /> : <div className="bg-white p-6 rounded max-w-6xl mx-auto border border-gray-200 shadow-md">
          {!accepted ? <AcceptAwards refetch={refetch} user={{ firstname }} /> :
            <>
              <CurrentLevel
                points={Number(fitPoints)}
                experiencePoints={Number(points)}
                levelName={levelName || ''}
                levels={levels}
                progressWidth={Number(progressWidth)}
              />
              <LevelProgress currentLevelName={levelName || ''} levels={levels} />
            </>}
        </div>}
        <AwardList />
        {awards && <ProgressSection
          awards={awards}
        />}
      </div>
    </div>
  );
}
